module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.svg?a0180954d7d374e153899d0974b25225";


//////////////////
// WEBPACK FOOTER
// ./app/assets/fonts/bootstrap/glyphicons-halflings-regular.svg
// module id = 150
// module chunks = 0